export default __webpack_public_path__ + "static/media/feather _ globe.5882488d.svg";